import { TabGroup } from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { FunctionComponent, useCallback, useMemo } from 'react';
import { UseFieldArrayReplace, UseFormWatch } from 'react-hook-form';

import { SelectPlanForm } from '../types';

export interface ProductFamilyTabGroupProps {
  watch: UseFormWatch<SelectPlanForm>;
  replace: UseFieldArrayReplace<SelectPlanForm, 'families'>;
}

export const ProductFamilyTabGroup: FunctionComponent<
  ProductFamilyTabGroupProps
> = ({ watch, replace }) => {
  const families = watch('families');
  const activeTab =
    families?.find(({ selected }) => selected)?.name || families[0].name;
  const tabs = families?.map(({ name, solutions, addons }) => {
    return {
      id: name,
      display: (
        <div className="grid grid-cols-3 w-full items-center gap-x-2 pl-4">
          <div className="col-span-2 flex flex-row gap-x-3 items-center">
            <img
              alt="solution"
              height={30}
              src={solutions[0].item.icons[0]}
              width={30}
            />
            {name}
          </div>
          <div className="col-span-1 w-7">
            {(solutions.filter(({ item }) => item.selectedTier).length > 0 ||
              addons.filter(({ item }) => item.selectedTier).length > 0) && (
              <div className="flex flex-row items-center justify-center text-secondary-800 border border-secondary-800 rounded-full w-7 h-7 ml-4">
                {solutions.filter(({ item }) => item.selectedTier).length +
                  (addons.filter(({ item }) => item.selectedTier).length || 0)}
              </div>
            )}
          </div>
        </div>
      ),
    };
  });

  const handleTabClick = useCallback(
    (tabId: string) => {
      const newFields = families.map((field) => {
        let selected = false;
        if (field.name === tabId) {
          selected = true;
        }

        return { ...field, selected };
      });
      replace(newFields);
    },
    [families, replace]
  );

  const divLength = useMemo(() => {
    if (tabs?.length === 1) {
      return 'w-1/3';
    }
    return 'w-3/5';
  }, [tabs]);

  return (
    <div className={`${divLength} h-full`}>
      <TabGroup active={activeTab} handleClick={handleTabClick} tabs={tabs} />
    </div>
  );
};
